import { c as _c } from "react/compiler-runtime";
import { Flag } from '@7f-ui/components/flag/flag';
import type { DealTag } from '@data-access/graphql/schema.types';
type AccommodationFlagProps = {
  isLowestPrice?: boolean;
  dealTag?: DealTag; // DealTag, since we might want to show the specific tag at some point
};
export function AccommodationFlag(t0) {
  const $ = _c(2);
  const {
    dealTag,
    isLowestPrice
  } = t0;
  if (dealTag) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Flag className="text-primary whitespace-nowrap py-0.5">Deal</Flag>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (isLowestPrice) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Flag className="text-primary whitespace-nowrap py-0.5" variant="success">Günstiger Preis</Flag>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  return null;
}